import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconChargingStation: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconChargingStation"><Path d="M9.21429 6.28577L6 10.2143H7.78571V12.7143L11 8.78577H9.21429V6.28577Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M3 3H14V19.5H21V21H3V3ZM4.5 4.5V14H12.5V4.5H4.5Z" fill="currentColor"/><Path d="M21 6.89875L17.154 3.69373L16.1937 4.84606L19.5 7.60131V15.5H17.5V10H16V17H21V6.89875Z" fill="currentColor"/></CentralIconBase>;
});

export default IconChargingStation;
